export default [
  {
    path: '/admin/correspondences/:category',
    name: 'indexCorrespondencesAdmin',
    meta: { title: 'indexCorrespondencesAdmin' },
    component: () => import('@/pages/correspondences'),
  },
  {
    path: "/admin/correspondences/:category/:type/create",
    name: "createCorrespondencesAdmin",
    meta: { title: 'createCorrespondencesAdmin' },
    component: () => import('@/pages/correspondences/create'),
  },
  {
    path: "/admin/correspondences/:id/edit",
    name: "editCorrespondencesAdmin",
    meta: { title: 'editCorrespondencesAdmin' },
    component: () => import('@/pages/correspondences/edit'),
  },
]
